import { LayoutDashboard, Radio, Ghost, Newspaper, Settings } from 'lucide-react';

const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'signals',   label: 'Signals',   icon: Radio },
  { key: 'shadow',    label: 'Shadow Trader', icon: Ghost },
  { key: 'news',      label: 'News & Calendar', icon: Newspaper },
  { key: 'settings',  label: 'Settings',  icon: Settings },
];

export default function SubTabBar({ active, onChange }) {
  return (
    <div className="flex gap-1 overflow-x-auto pb-1 scrollbar-thin">
      {TABS.map(tab => {
        const Icon = tab.icon;
        const isActive = active === tab.key;
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-mono font-bold whitespace-nowrap transition-all ${
              isActive
                ? 'bg-korinth-accent/10 text-korinth-accent border border-korinth-accent'
                : 'text-korinth-muted border border-transparent hover:bg-korinth-border/50 hover:text-korinth-text'
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
